module.exports = __webpack_public_path__ + "assets/building.f9753890.svg";